import React from "react";
export class Hamburger extends React.Component {
  render() {
    return (
      <button
        className={`hamburger ${this.props.isMenuOpen ? "active" : ""}`}
        onClick={this.props.toggleOpenMenu}
      >
        <div />
        <div />
        <div />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Hamburger.js